import { apiFetch } from '../lib/api';

export interface ListingResult {
  wheel_id: number;
  sku: string;
  listing: any;
}

export function generateListing(wheelId: number): Promise<ListingResult> {
  return apiFetch(`/admin/generate-listing/${wheelId}`, { method: 'POST' });
}
